import { createRequestTypes } from "../../utils";


// Fetch recipies proportions
export const FETCH_RECIPES_PROPORTIONS = createRequestTypes("FETCH_RECIPES_PROPORTIONS");
export const fetchRecipeProportionsRequest = (payload) =>
  ({ type: FETCH_RECIPES_PROPORTIONS.REQUEST, payload });
export const fetchRecipeProportionsSuccess = (payload) =>
  ({ type: FETCH_RECIPES_PROPORTIONS.SUCCESS, payload });
export const fetchRecipeProportionsFailure = (error) =>
  ({ type: FETCH_RECIPES_PROPORTIONS.FAILURE, payload: { error } });


// Fetch recipies instructions
export const FETCH_RECIPES_INSTRUCTIONS = createRequestTypes("FETCH_RECIPES_INSTRUCTIONS");
export const fetchRecipeInstructionsRequest = (recipe) =>
  ({ type: FETCH_RECIPES_INSTRUCTIONS.REQUEST, payload: { recipe } });
export const fetchRecipeInstructionsSuccess = (payload) =>
  ({ type: FETCH_RECIPES_INSTRUCTIONS.SUCCESS, payload });
export const fetchRecipeInstructionsFailure = (error) =>
  ({ type: FETCH_RECIPES_INSTRUCTIONS.FAILURE, payload: { error } });

